<template>
<form @submit.prevent="post">
    <div :class="['form-group', { 'has-error': form.errors.has('message') }]">
        <wysiwyg v-model="form.message" ref="replyBox" @input="validate('message')" :buttons="['bold', 'italic', 'underline', 'lists']"></wysiwyg>
        <span class="help-block" v-if="form.errors.has('message')">{{ form.errors.get('message') }}</span>
    </div>
    <button class="btn btn-default" @click.prevent="showMediaPicker = !showMediaPicker"><i class="fa fa-camera"></i> {{ t.add_media }}</button>
    <button type="submit" class="btn btn-primary pull-right" :disabled="loading || form.errors.any() || !validated">
        <span v-if="!loading">{{ t.add_reply }}</span>
        <loading v-if="loading" :small="true"></loading>
    </button>
    <CheckBoxes class="watch pull-right" :options="[{value: 1, text: t.watch}]"
        v-model="form.watch"
        @input="(v) => { form.watch = v ? 1 : 0 }"></CheckBoxes>
    <div class="clearfix"></div>
    <div class="forum-post-form-media">
        <media v-for="media in medias" :key="media.id" :media="media" :private-allowed="true" :stats="false"
            :card="false" :selectable="false" size="small">
            <span class="fa-stack fa-stack-remove fa-lg" @click="removeMedia(media)">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-remove fa-stack-1x fa-inverse"></i>
            </span>
        </media>
    </div>
    <modal v-model="showMediaPicker" :title="t.add_media" :submit="t.add">
        <wall-media-picker @select-media="updateMedia"></wall-media-picker>
    </modal>
</form>
</template>

<script>
import { mapState } from 'vuex';
import CheckBoxes from 'Site/component/CheckBoxes.vue';
import Form from 'Site/js/util/form';
import forumMediaMixin from 'Forum/js/mixin/forumMedia';
import Loading from 'Site/component/Loading.vue';
import Wysiwyg from 'Site/component/Wysiwyg.vue';

export default {
    name: 'ForumPostForm',
    components: {
        CheckBoxes,
        Loading,
        Wysiwyg
    },
    computed: mapState(['gt', 't']),
    data() {
        return {
            form: new Form({
                forumId: this.forum,
                forumName: this.forumName,
                media: [],
                message: '',
                threadId: this.thread,
                watch: 1
            }),
            loading: false,
            validated: false
        };
    },
    mixins: [forumMediaMixin],
    methods: {
        focus(quotePost) {
            if (quotePost) {
                const quote = `<p><blockquote>
                    <cite>${this.t.quote_by.replace('%user', quotePost.user.userName)}</cite>
                    <br>
                    ${quotePost.text}
                </blockquote>&nbsp;</p>`;
                this.form.message = `${quote}${this.form.message}`;
            }
            this.$refs.replyBox.focus();
        },
        validate(field) {
            this.validated = true;
            this.form.errors.clear(field);
            this.form.validate(field);
        },
        post() {
            this.form.media = this.medias.map(mediaItem => mediaItem.id);
            const form = this.form.create('post');
            if (form) {
                this.loading = true;
                form.then((response) => {
                    this.loading = false;
                    this.validated = false;
                    this.$store.dispatch('notify', { msg: response.message });
                    if (this.isLastPage) {
                        this.$emit('create', response.item);
                    } else {
                        window.location = response.url;
                    }
                    this.medias = [];
                });
            }
        }
    },
    props: {
        forum: {
            type: Number,
            required: true
        },
        forumName: {
            type: String,
            required: true
        },
        isLastPage: {
            type: Boolean,
            default: false
        },
        thread: {
            type: Number,
            required: true
        }
    }
};

</script>

<style lang="scss">
.forum-post-form-media {
    margin: 0 5px;
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
    .fa-remove {
        color: #fff;
    }
}
</style>

<style lang="scss" scoped="true">
.btn-default i {
    margin-right: 5px;
}
.watch {
    width: 75px;
    margin-right: 10px;
}
</style>
